import { useExtendWithSubnetworks, useNetworksStateContext } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADSIDE } from "../../../../common/constants/appRoad"

import { roadsideQueryKeys } from "./queryKeys"
import { useRoadsideQuery } from "./useRoadsideQuery"

export function useRoadsideInventories(parameters = {}, config: any = {}) {
    const url = "roadside_inventories/"
    const { selectedNetwork } = useNetworksStateContext()

    const queryParameters = useExtendWithSubnetworks({
        ...parameters,
        project: selectedNetwork.slug,
    }, API_MODULE_ROADSIDE)

    const queryKey = roadsideQueryKeys["list"](queryParameters)

    return useRoadsideQuery(
        url,
        queryKey,
        queryParameters,
        {
            ...config,
            enabled: config.enabled && !!selectedNetwork,
        },
    )
}